// @flow
import * as R from "ramda"
import { stringify } from "query-string"

type Params = {
  [key: string]: string,
}

/**
 * @param query - format: ?key=val&key2=val2 | key=val&key2=val2
 * @returns {Object<string, string>}
 */
export function parseQuery(query: string = ""): Params {
  return query
    .replace(/(^\?)/, "")
    .split("&")
    .filter(Boolean)
    .reduce((obj, pair) => {
      const [key, val] = pair.split("=").map(decodeURIComponent)
      return Object.assign(obj, {
        [key]: val,
      })
    }, {})
}

type MakeParams = {
  [key: string]: any, // eslint-disable-line flowtype/no-weak-types
}

/**
 * @param params - Object of strings
 * @param pure - if true, skip "?" from returned string
 * @returns string
 */
export function makeQuery(params: MakeParams, pure: boolean = false): string {
  const qmark = pure ? "" : "?"
  return qmark + stringify(params)
}

/**
 * @param query - format: ?key=val&key2=val2 | key=val&key2=val2
 * @param keys - parameters to remove
 * @returns query starting with "?"
 */
export function removeParams(query: string, ...keys: Array<string>): string {
  return makeQuery(R.omit(keys, parseQuery(query)))
}
